import type { PatientStrings } from '../index';

export const kn: PatientStrings = {
  titleOne: 'ನಿಮ್ಮ ಹೊಸ ಕ್ರೌನ್',
  titleMany: 'ನಿಮ್ಮ ಹೊಸ ಕ್ರೌನ್‌ಗಳು',
  tooth: 'ಹಲ್ಲು',
  teeth: 'ಹಲ್ಲುಗಳು',
  both: 'ಎರಡೂ',
  overview: 'ಪೂರ್ಣ ನೋಟ',
  front: 'ಮುಂಭಾಗ',
  leftSide: 'ಎಡ ಬದಿ',
  rightSide: 'ಬಲ ಬದಿ',
  bitingSurface: 'ಅಗಿಯುವ ಮೇಲ್ಮೈ',
  show: 'ತೋರಿಸು',
  newCrown: 'ಹೊಸ ಕ್ರೌನ್',
  newCrowns: 'ಹೊಸ ಕ್ರೌನ್‌ಗಳು',
  yourTeeth: 'ನಿಮ್ಮ ಹಲ್ಲುಗಳು ಮತ್ತು ವಸಡು',
  upperTeeth: 'ಮೇಲಿನ ಹಲ್ಲುಗಳು',
  lowerTeeth: 'ಕೆಳಗಿನ ಹಲ್ಲುಗಳು',
  hint: 'ತಿರುಗಿಸಲು ಎಳೆಯಿರಿ · ಜೂಮ್ ಮಾಡಲು ಪಿಂಚ್ ಅಥವಾ ಸ್ಕ್ರೋಲ್ ಮಾಡಿ',
  zoomIn: 'ಹತ್ತಿರ',
  zoomOut: 'ದೂರ',
  turnSlowly: 'ನಿಧಾನವಾಗಿ ತಿರುಗಿಸು',
  stopTurning: 'ತಿರುಗಿಸುವುದನ್ನು ನಿಲ್ಲಿಸು',
  backToStart: 'ಆರಂಭಕ್ಕೆ',
  fullScreen: 'ಪೂರ್ಣ ಪರದೆ',
  exitFullScreen: 'ಪೂರ್ಣ ಪರದೆಯಿಂದ ಹೊರಗೆ',
  fromDentist: 'ನಿಮ್ಮ ದಂತ ವೈದ್ಯರಿಂದ',
  shadeNote: (shade) =>
    `ಬಣ್ಣವನ್ನು ಸುಮಾರು ಶೇಡ್ ${shade} ನಂತೆ ತೋರಿಸಲಾಗಿದೆ. ನಿಜವಾದ ಕ್ರೌನ್‌ನ ಬಣ್ಣವನ್ನು ಲ್ಯಾಬ್‌ನಲ್ಲಿ ಹೊಂದಿಸಲಾಗುತ್ತದೆ.`,
  before: 'ಮೊದಲು',
  after: 'ನಂತರ',
  seeInRoom: 'ನಿಮ್ಮ ಕೋಣೆಯಲ್ಲಿ ನೋಡಿ',
  arNotSupported: 'ಕ್ರೌನ್ ಅನ್ನು ನಿಮ್ಮ ಕೋಣೆಯಲ್ಲಿ ನೋಡಲು ಈ ಪುಟವನ್ನು ನಿಮ್ಮ ಫೋನ್‌ನಲ್ಲಿ ತೆರೆಯಿರಿ.',
  appointmentTitle: 'ಕ್ರೌನ್ ಅಳವಡಿಸುವ ನಿಮ್ಮ ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್',
  confirm: 'ದೃಢೀಕರಿಸಿ',
  confirmed: 'ದೃಢೀಕರಿಸಲಾಗಿದೆ — ಆಗ ಭೇಟಿಯಾಗೋಣ',
  anotherTime: 'ಬೇರೆ ಸಮಯ ಕೇಳಿ',
  anotherTimeSent: 'ನಿಮಗೆ ಬೇರೆ ಸಮಯ ಬೇಕೆಂದು ನಿಮ್ಮ ದಂತ ವೈದ್ಯರಿಗೆ ತಿಳಿಸಿದ್ದೇವೆ.',
  language: 'ಭಾಷೆ',
  largerText: 'ದೊಡ್ಡ ಅಕ್ಷರ',
};
